import {AfterViewInit, Component} from "@angular/core";
import * as module from "module";
import {contextPath} from "site";
import * as user from "user";
import {addButtonToSsoPortal} from "../sso-portal-module";

@Component({
	selector: "device-management-overview",
	template: `
		<h1>Manage Your Garmin Aviation Devices</h1>
		<div class="devicesoverview_heading">
			<image-container class="devicesoverview_heading_image" [height]="120" [width]="100"
							 [src]="'https://static.garmincdn.com/apps/fly/img/devices/NXi-G1000-00.jpg'"
							 [alt]="'G1000 NXi'"></image-container>
			<image-container class="devicesoverview_heading_image" [height]="120" [width]="100"
							 [src]="'https://static.garmincdn.com/apps/fly/img/devices/010-00813-01.jpg'"
							 [alt]="'GTN 6 Series'"></image-container>
			<image-container class="devicesoverview_heading_image" [height]="120" [width]="100"
							 [src]="'https://static.garmincdn.com/apps/fly/img/devices/010-00967-01.jpg'"
							 [alt]="'Aera 7 Series'"></image-container>
			<image-container class="devicesoverview_heading_image" [height]="120" [width]="100"
							 [src]="'https://static.garmincdn.com/apps/fly/img/devices/010-01338-35.jpg'"
							 [alt]="'D2 Bravo'"></image-container>
		</div>
		<div class="layout-columns devicesoverview_columns">
			<div class="layout-column66-stackable">
				<h2 class="devicesoverview_section_label">Aviation Databases</h2>
				<h3>Keep all of your aviation databases up-to-date in 3 easy steps:</h3>
				<ul class="steps">
					<li>
						<h3>Add Your Devices</h3>
						<p>
							Add each of your Garmin avionics systems and portable aviation devices to flyGarmin. We will walk you
							through adding your devices and gathering system information needed to install database updates.
						</p>
						<a class="button button-primary" routerLink="/add-device">Add A New Device</a>
					</li>
					<li>
						<h3>Purchase Database Updates</h3>
						<p>
							Whether you need a single database for an upcoming trip or annual coverage for all of your
							devices, we have just the right package for you. Based on your
							equipment, the regions in which you fly, and the type of flying you do, we'll help you find the most
							cost-efficient solution that suits your needs.
						</p>
					</li>
					<li>
						<h3>Install Database Updates</h3>
						<p>
							Using database concierge or the <a href="{{contextPath}}/garmin-aviation-database-manager/">Garmin Aviation Database Manager</a>
							to install your database updates is simple and intuitive.
							Garmin Aviation Database Manager will even walk you through gathering the equipment you need, downloading
							databases to your computer, and installing databases on your data card or device.
						</p>
					</li>
				</ul>
			</div>
			<div class="layout-column33-stackable">
				<div *ngIf="!user.signedIn" class="devicesoverview_info_group">
					<h4 class="devicesoverview_section_label devicesoverview_widget_label">Garmin Account Sign In</h4>
					<div class="button-to-sso-portal">
						<div class="loading-indicator">Loading...</div>
					</div>
				</div>
				<div class="devicesoverview_info_group">
					<h2 class="devicesoverview_section_label">Connected-Cockpit Services</h2>
					<h3>Activate Subscriptions for your Avionics, including:</h3>
					<ul class="devicesoverview_info_group_list">
						<li>
							<a href="{{contextPath}}/connext/worldwide-weather/">Worldwide Weather</a>
						</li>
						<li>Voice & Text</li>
						<li>Position Reporting</li>
						<li>Maintenance Reporting</li>
					</ul>
					<div class="devicesoverview_info_group_links">
						<a class="button button-primary" href="{{contextPath}}/connext/satellite-services/">Pricing</a>
						<a class="button" href="{{contextPath}}/connext/satellite-services/sign-up/">Sign Up</a>
					</div>
				</div>
				<div class="devicesoverview_info_group">
					<h2 class="devicesoverview_section_label">Warranty</h2>
					<p class="devicesoverview_info_group_details">Product Registration:</p>
					<ul class="devicesoverview_info_group_list">
						<li>
							<a href="{{contextPath}}/devices/warranty-registration/panel-mount">Panel-Mounted Avionics / Devices</a>
						</li>
						<li>
							<a href="{{contextPath}}/devices/warranty-registration/portable">Portable Aviation Devices</a>
						</li>
					</ul>
					<p class="devicesoverview_info_group_details">Warranty Information:</p>
					<ul class="devicesoverview_info_group_list">
						<li>
							<a href="http://www.garmin.com/en-US/legal/aviation-limited-warranty">Aviation Standard Warranty</a>
						</li>
					</ul>
				</div>
			</div>
		</div>
	`,
})
export class DeviceManagementOverviewComponent implements AfterViewInit {
	contextPath = contextPath;
	user = user;

	ngAfterViewInit(): void {
		if (!user.signedIn) {
			addButtonToSsoPortal(module.config().ssoPortalUrl, module.config().ssoPortalClientId, module.config().ssoPortalRedirectUrl)

		}
	}
}
